export function resolveRunStartedAt(source) {
  if (!source) return null;
  return (
    source.runStartedAt ||
    source.activeRunStartedAt ||
    source.latestRun?.startedAt ||
    source.latestRun?.started_at ||
    null
  );
}

/** Rough human elapsed label for an in-progress sync (e.g. "~12m", "~1h 5m"). */
export function formatRunningElapsed(startedAt, nowMs = Date.now()) {
  if (!startedAt) return null;
  const startMs = new Date(startedAt).getTime();
  if (!Number.isFinite(startMs)) return null;

  const elapsedMs = Math.max(0, nowMs - startMs);
  const totalSeconds = Math.floor(elapsedMs / 1000);

  if (totalSeconds < 45) {
    return "just started";
  }
  if (totalSeconds < 90) {
    return "~1m";
  }

  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) {
    return `~${totalMinutes}m`;
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (minutes === 0) {
    return `~${hours}h`;
  }
  return `~${hours}h ${minutes}m`;
}
